// extracted by mini-css-extract-plugin
export var details = "MarkdownReference-module--details--33964";
export var root = "MarkdownReference-module--root--f7202";
export var wave = "MarkdownReference-module--wave--98d57";